import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";
import { SelectOptions } from "hooks";

const templatesState = (state: AppState) => state.templates.overview;

export const getTemplatesProcessingState = createSelector(templatesState, ({ hasError, isProcessing, isDeleting }) => ({
    hasError,
    isProcessing,
    isDeleting,
}));

export const getTemplates = createSelector(templatesState, ({ emailTemplates }) =>
    emailTemplates.map(({ userGroups, ...emailTemplate }) => ({
        ...emailTemplate,
        userGroups: userGroups.map<SelectOptions>(({ id, name }) => ({
            name,
            value: id,
        })),
    }))
);

export const getAllUserGroups = createSelector(templatesState, ({ userGroups }) =>
    userGroups.map<SelectOptions>(({ id, name }) => ({
        name,
        value: id,
    }))
);
